import { supabase } from './supabase'

// One in-flight get_my_profile per uid: several boot hooks ask for the same row at once.
const inflight = new Map()
export function fetchMyProfile(uid) {
  if (inflight.has(uid)) return inflight.get(uid)
  const p = Promise.resolve(supabase.rpc('get_my_profile').maybeSingle()).finally(() => inflight.delete(uid))
  inflight.set(uid, p)
  return p
}
